@import '../../UI/MarkdownContent/MarkdownTable.module.less';

.reasoningText {
    max-width: 100%;
    overflow: auto;

    padding: 15px;
    color: #dc6803;
    font-family: Hanken Grotesk;
    font-size: 15px;
    font-weight: 400;
    line-height: 1.2;
}

.messageDetailsButton {
    position: absolute;
    top: 15px;
    right: 16px;
}

.message_text_style {
    font-size: 15px;
    line-height: 1.3;
    font-weight: 500;
    font-family: Hanken Grotesk;
    color: #323b48;
}

.contentBase {
    .message_text_style();
    .fl_markdown_table();
    max-width: 70%;
}

.logoBackgroundBase {
    background-color: #0142e5;
    border-radius: 20px;
    width: 35px;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 23px;
    margin-right: 20px;

    img {
        width: 24px;
        height: 24px;
    }
}
